import React, { useEffect, useState } from "react";
import SplitPane from "react-split-pane";
import { Form, Offcanvas, Table } from "react-bootstrap";
import { useParams } from "react-router";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { FaEye, FaEyeSlash, FaSquarePlus, FaTrash } from "react-icons/fa6";
import { studyDatasetsServices } from "../../../../APIServices/studyDatasetsServices";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const AddPeriod = ({ tableRef, onMouseDown, Show, Hide, Title, getStudyDataTransfered }) => {
  const [datasetsList, setDatasetsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateTransfer, setDateTransfer] = useState("");
  const [timeTransfer, setTimeTransfer] = useState("");
  const [period, setPeriod] = useState("");
  const [logoutTime, setLogoutTime] = useState("");
  const [password, setPassword] = useState("");
  const [datasets, setDatasets] = useState([]);
  let { studyId } = useParams();
  const [showPassword, setShowPassword] = useState(true);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelForm = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active"
    );
    setDatasetsList(data?.data || []);
    setLoading(false);
  };

  // const [newEmail, setNewEmail] = useState("");

  // const handleAddEmail = () => {
  //   const trimmed = newEmail.trim();
  //   const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
  //   if (isValid) {
  //     setEmails((prev) => [...prev, trimmed]);
  //     setNewEmail("");
  //   } else {
  //     handleResponse({
  //       statusCode: 400,
  //       customMessage: "Please enter a valid email.",
  //     })
  //   }
  // };

  // const handleRemoveEmail = (index) => {
  //   setEmails((prev) => prev.filter((_, i) => i !== index));
  // };

  // const handleKeyPress = (e) => {
  //   if (e.key === "Enter") handleAddEmail();
  // };
  const [emails, setEmails] = useState([]);

  const handleAddEmailField = () => {
    setEmails((prev) => [...prev, ""]);
  };

  const handleRemoveEmail = (index) => {
    setEmails((prev) => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated.length === 0 ? [""] : updated;
    });
  };

  const handleEmailChange = (index, value) => {
    const updated = [...emails];
    updated[index] = value;
    setEmails(updated);
  };

  const handleChangeCheckbox = (formId) => {
    setDatasets((prevSelected) => {
      if (prevSelected.includes(formId)) {
        return prevSelected.filter((id) => id !== formId);
      } else {
        return [...prevSelected, formId];
      }
    });
  };

  const handleSelectAll = () => {
    if (datasets?.length === datasetsList.length) {
      setDatasets([]);
    } else {
      const allFormIds = datasetsList.map((item) => item.formId);
      setDatasets(allFormIds);
    }
  };

  const addNewDatasetTransfer = async () => {
    let userData = {}
    userData.transferDate = dateTransfer
    userData.transferTime = timeTransfer
    userData.period = period
    userData.password = password
    userData.timer = logoutTime
    userData.datasets = datasets
    userData.emails = emails
    userData.studyId = studyId
    userData.type = "period"
    userData.mode = StudyMode
    let data = await studyDatasetsServices.addNewDatasetTransfer(userData)
    if (data?.statusCode === 200) {
      getStudyDataTransfered()
      Hide()
    }
  }

  useEffect(() => {
    getStudyLevelForm();
  }, []);

  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 900 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <SplitPane
            split="vertical"
            minSize={"60%"}
            style={{ height: "-webkit-fill-available" }}
          >
            {loading ? (
              <PageLoader/>
            ) : (
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      <Form.Check
                        checked={datasets?.length === datasetsList.length && datasetsList.length > 0}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Datasets</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Datasets Code</th>
                  </tr>
                </thead>
                <tbody>
                  {datasetsList.map((data, index) => (
                    <tr className="CP" key={index}>
                      <td className="text-center">
                        <Form.Check
                          checked={datasets?.includes(data.formId)}
                          onChange={() => handleChangeCheckbox(data.formId)}
                        />
                      </td>
                      <td>{data?.formName}</td>
                      <td>{data?.formCode}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

            )}
            <div className="p-2">
              <Form.Group className="mb-1">
                <Form.Label className="mb-1 fw-bold">
                  Date for transfer{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Control
                  type="date"
                  className="fontSize12"
                  onChange={(e) => setDateTransfer(e.target.value)}
                  value={dateTransfer}
                />
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.Label className="mb-1 fw-bold">
                  Time for transfer{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Control
                  type="time"
                  className="fontSize12"
                  onChange={(e) => setTimeTransfer(e.target.value)}
                  value={timeTransfer}
                />
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.Label className="mb-1 fw-bold">
                  Logout Time{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Control
                  type="number"
                  className="fontSize12"
                  placeholder="Enter Logout Time in Minute"
                  onChange={(e) => setLogoutTime(e.target.value)}
                  value={logoutTime}
                />
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.Label className="mb-1 fw-bold">
                  Period{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter No of Day's"
                  className="fontSize12"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (Number(value) < 0) return;
                    setPeriod(value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  value={period}
                />
              </Form.Group>
              <div className="position-relative">
                <Form.Label className="mb-1 fw-bold">
                  Password{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Control
                  type={showPassword ? "password" : "text"}
                  placeholder={`Enter Password`}
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                />
                <div
                  className="position-absolute CP"
                  style={{ top: 27, right: 7, cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash title="Hide Password" /> : <FaEye title="Reveal Password" />}
                </div>
              </div>
              <Form.Group className="mb-3">
                <Form.Label className="mb-1 fw-bold">
                  Emails{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>{" "}
                  <FaSquarePlus className="ms-2 CP" title="Add more emails" onClick={handleAddEmailField} />
                </Form.Label>
                {(emails.length > 0 ? emails : [""]).map((email, index) => (
                  <div key={index} className="d-flex align-items-center mb-2">
                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => handleEmailChange(index, e.target.value)}
                      className="me-2"
                    />
                    {emails.length > 1 && (
                      <FaTrash
                        className="text-danger CP"
                        onClick={() => handleRemoveEmail(index)}
                        style={{fontSize: 12}}
                        title="Remove Email"
                      />
                    )}
                  </div>
                ))}
              </Form.Group>
              <div className="text-end">
                <button
                  onClick={addNewDatasetTransfer}
                  disabled={!logoutTime || !dateTransfer || !timeTransfer || !period || !password || datasets?.length === 0 || !emails}
                  title={Title}
                  className="updateProfile"
                >
                  {Title}
                </button>
              </div>
            </div>
          </SplitPane>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AddPeriod;
